import { call, put, takeLatest } from 'redux-saga/effects';

import { monolithApiUrl } from '../../config/app';
import { endpoints } from '../../constants/routing';
import { IEditEngagementRequestPayload } from '../../types/bucket';
import { IReduxAction } from '../../types/redux';
import { mapSendItemsForEditSendRequest } from '../../utils/reports';
import { buildEndpointRoute } from '../../utils/routing';
import * as EngagementActions from '../actions/engagement';
import { AuthRequest } from './helpers';

export function* editEngagementWorkerSaga(
  action: IReduxAction<IEditEngagementRequestPayload>,
): Generator<any, any, any> {
  const { resolve, reject, engagement } = action.payload || {};
  try {
    if (engagement) {
      const { items_info, engagement_id, ...rest } = engagement;

      if (!engagement_id) {
        throw new Error('Engagement ID is required');
      }
      const endpoint = `${monolithApiUrl}${buildEndpointRoute(endpoints.editEngagement, { id: engagement_id })}`;

      const body = JSON.stringify({
        ...mapSendItemsForEditSendRequest(items_info),
        ...rest,
      });

      const response = yield call<any>(AuthRequest, {
        method: 'PUT',
        endpoint,
        body,
      });

      if (!response.ok) {
        yield put(EngagementActions.editEngagementFailure(response.body));
        if (reject) {
          yield call(reject, response);
        }
      } else {
        yield put(EngagementActions.editEngagementSuccess({ engagement }));
        if (resolve) {
          yield call(resolve, response);
        }
      }
    } else if (reject) {
      yield call(reject, {
        message: 'An error has occurred! No engagement to edit',
      });
    }
  } catch (error) {
    if (reject) {
      yield call(reject, error);
    }
  }
}

const sagas = {
  *watchEditEngagementRequest() {
    yield takeLatest(EngagementActions.EDIT_ENGAGEMENT_REQUEST, editEngagementWorkerSaga);
  },
};

export default sagas;
